import { Box, Button, Chip } from '@mui/material';
import { type MouseEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ExplanationDialog } from './explanation-dialog';

/**
 * Chip "Beta" che spiega da sola cosa significa: ovunque compaia (intestazione
 * di pagina, menu laterale) un tocco apre la spiegazione con un esempio e
 * l'invito a verificare i risultati.
 */
export function BetaChip() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  function handleOpen(event: MouseEvent<HTMLElement>) {
    // Nel menu laterale il chip sta dentro una voce cliccabile: aprire la
    // spiegazione non deve navigare.
    event.stopPropagation();
    event.preventDefault();
    setOpen(true);
  }

  return (
    <>
      <Chip
        label={t('common.betaChip')}
        size="small"
        color="info"
        onClick={handleOpen}
        aria-label={t('common.betaExplainer.openLabel')}
        sx={{
          flexShrink: 0,
          position: 'relative',
          '&::after': {
            content: '""',
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: '100%',
            minWidth: 48,
            height: 48,
            transform: 'translate(-50%, -50%)',
          },
        }}
      />
      <ExplanationDialog
        open={open}
        onClose={() => setOpen(false)}
        title={t('common.betaExplainer.title')}
        actions={
          <Button variant="contained" sx={{ minHeight: 48 }} onClick={() => setOpen(false)}>
            {t('common.betaExplainer.confirm')}
          </Button>
        }
      >
        <Box component="span" sx={{ display: 'block', mb: 1.5 }}>
          {t('common.betaExplainer.meaning')}
        </Box>
        <Box component="span" sx={{ display: 'block', mb: 1.5 }}>
          {t('common.betaExplainer.example')}
        </Box>
        <Box component="span" sx={{ display: 'block', fontWeight: 700, color: 'text.primary' }}>
          {t('common.betaExplainer.verify')}
        </Box>
      </ExplanationDialog>
    </>
  );
}
